import React from 'react';
import { useTranslation } from '../i18n/useTranslation';
import { getSignalPathBadge } from '../utils/signalPath';

const BADGE_STYLE = {
  fontSize: 9,
  fontWeight: 500,
  padding: '1px 6px',
  borderRadius: 4,
  color: 'var(--text-tertiary)',
  background: 'var(--bg-secondary)',
  border: '1px solid var(--border)',
  whiteSpace: 'nowrap',
  cursor: 'help',
  letterSpacing: '0.02em',
};

export default function SignalPathBadge({ zone, className = '' }) {
  const { t } = useTranslation();
  const badge = getSignalPathBadge(zone);
  if (!badge) return null;

  return (
    <span
      className={className}
      title={t(badge.tooltipKey)}
      style={BADGE_STYLE}
      data-signal-path-badge={badge.labelKey}
    >
      {t(badge.labelKey)}
    </span>
  );
}
